<!-- Search Control -->
<div class="h-full"
  [ngClass]="{'max-h-modal': isModal()}">
  <!-- Search Results -->
  <div class="overflow-hidden h-full">
    <!-- Data View -->
    @let layout = (slideAuthorFacade.layout$ | async) ?? 'list';
    @if (searchControlFacade.nodeSearchResult$ | async; as nodeSearchResult) {
      <medsurf-design-content-sortable-data-view
        [value]="nodeSearchResult.items"
        [gridStyleClass]="'flex flex-wrap gap-2 ' + (!isModal() ? 'p-2' : 'pb-2')"
        [listStyleClass]="(!isModal() ? 'p-2' : 'pb-2')"
        [paginatorDropdownScrollHeight]="'300px'"
        [trackBy]="trackBy"
        [rows]="searchForm.value.rows || 10"
        [layout]="layout"
        (onChangeLayout)="changeLayout($event)"
        [pageLinks]="5"
        [totalRecords]="nodeSearchResult.total"
        [paginator]="true"
        [lazy]="true"
        [draggable]="false"
        [first]="searchForm.value.first || 0"
        (onLazyLoad)="onLazy($event)"
        (onPage)="onSubmit(false)">
        <!-- Header -->
        <ng-template pTemplate="header"
          class="overflow-scroll h-full">
          <div [class]="'flex gap-2 w-full ' + (!isModal() ? 'p-2' : 'pt-2')">
            <div class="flex-grow-1">
              <medsurf-design-form-control-form [formGroup]="searchForm"
                [class]="'w-full'"
                (onSubmit)="onSubmit()">
                <div class="flex flex-wrap gap-2">
                  <!-- Search String -->
                  <medsurf-design-form-control-input-text #searchStringInputText
                    [formField]="false"
                    [control]="searchForm.controls.searchString"
                    [autofocus]="true"
                    [class]="'flex-grow-1'"
                    [inputType]="'text'"
                    [placeholder]="'global.search_query'"
                  (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                  <!-- Type Filter -->
                  <medsurf-design-form-control-input-multi-select [formField]="false"
                    [control]="searchForm.controls.typeFilter"
                    [options]="FlatModels.PageEntityModels.AllowedSearchPageTypeArray | keyvalue"
                    [class]="'flex-grow-1'"
                    [optionValue]="'key'"
                    [optionLabel]="'key'"
                    [placeholder]="'global.file_type'"
                  (valueChange)="onSubmit()"></medsurf-design-form-control-input-multi-select>
                  <!-- Uploaded By Me -->
                  <medsurf-design-form-control-input-switch [formField]="false"
                    [control]="searchForm.controls.createdByMe"
                    [label]="'global.uploaded_by_me'"
                    [class]="'flex'"
                    [labelTop]="false"
                  (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
                  <!-- Used In Filter -->
                  <medsurf-design-form-control-input-node-tree-select [formField]="false"
                    [control]="searchForm.controls.usedInFilter"
                    [class]="'flex-grow-1'"
                    [placeholder]="'global.used_in'"
                  (valueChange)="onSubmit()"></medsurf-design-form-control-input-node-tree-select>
                </div>
              </medsurf-design-form-control-form>
            </div>
            <div class="flex flex-shrink-0 gap-2">
              <!-- Layout Options -->
              <medsurf-design-content-sortable-data-view-layout-options [layout]="layout"></medsurf-design-content-sortable-data-view-layout-options>
            </div>
          </div>
          <div class="p-2">
            @if (layout === 'list') {
              <div class="table-head h-5rem pl-2 pr-3 cursor-pointer overflow-hidden"
                >
                <div class="w-2rem">
                  &nbsp;
                </div>
                <div class="w-5rem flex-shrink-0">
                  &nbsp;
                </div>
                <div class="w-20rem flex-grow-1">
                  <span translate="global.title"></span>
                </div>
                <div class="w-30rem">
                  <span translate="global.breadcrumb"></span>
                </div>
                <div class="w-5rem">
                  <span translate="global.access"></span>
                </div>
              </div>
            }
          </div>
        </ng-template>
        <!-- Content -->
        <!-- List Item -->
        <ng-template pTemplate="listItem"
          let-node
          let-rowIndex="rowIndex">
          @if ({
            hasBulkEditNode: bulkEditAuthorFacade.hasBulkEditNode$(node.id) | async,
            node: searchControlFacade.currentSelectedNode$ | async
          }; as nodeData) {
            <div class="table-row align-items-center w-full h-5rem pl-2 cursor-pointer overflow-hidden hover:bg-primary-200 node"
              [ngClass]="{'bg-primary-300': nodeData.hasBulkEditNode && !isModal() || nodeData.node === node.id}"
              (click)="onNodeClick(node)"
              (dblclick)="isModal() && nodeData.node && onModalSubmit(nodeData.node)">
              <div class="w-2rem">
                {{ searchForm.value.first + rowIndex + 1 }}
              </div>
              <div class="w-5rem flex-shrink-0">
                <img class="block h-4rem w-4rem bg-black-alpha-30"
                  [src]="mediaControlService.getUrl(node.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="node?.title || 'global.error_loading_image' | translate" />
              </div>
              <div class="w-20rem flex-grow-1 text-overflow-ellipsis-2">
                {{ node.title }}
              </div>
              <div class="w-30rem text-overflow-ellipsis-2">
                {{ node.path }}
              </div>
              <div class="w-5rem">
                {{ node.hidden }}
              </div>
            </div>
          }
        </ng-template>
        <!-- Grid Item -->
        <ng-template pTemplate="gridItem"
          let-node>
          @if ({
            hasBulkEditNode: bulkEditAuthorFacade.hasBulkEditNode$(node.id) | async,
            node: searchControlFacade.currentSelectedNode$ | async
          }; as nodeData) {
            <div class="flex flex-column w-12rem h-16rem border-1 border-round cursor-pointer overflow-hidden hover:border-primary-200 hover:bg-primary-200 node border-secondary"
              [ngClass]="{'bg-primary-300': nodeData.hasBulkEditNode && !isModal() || nodeData.node === node.id}"
              [title]="node.title"
              (click)="onNodeClick(node)"
              (dblclick)="isModal() && nodeData.node && onModalSubmit(nodeData.node)">
              <div class="relative w-12rem h-12rem">
                <div class="absolute top-0 left-0 m-2 flex gap-1">
                  <medsurf-design-content-chip [tooltipLabel]="(node.mediaType ? 'enum.media' + node.mediaType : 'MediaUnknown') | translate">
                    <i [class]="mediaControlService.getMediaTypeIconByType(node.mediaType)"
                    class="align-self-start"></i>
                  </medsurf-design-content-chip>
                  @if (node.type !== FlatModels.PageEntityModels.PageType.enum.Slide) {
                    <medsurf-design-content-chip
                      [tooltipLabel]="('enum.pageType.' + node.type) | translate">
                      <i [class]="FlatModels.PageEntityModels.PageTypeIcon[node.type]"
                      class="align-self-start"></i>
                    </medsurf-design-content-chip>
                  }
                </div>
                @if (node.hidden) {
                  <medsurf-design-content-chip
                    [tooltipLabel]="'global.node_not_visible' | translate"
                    [class]="'absolute bottom-0 left-0 m-2'">
                    <i class="fa fal fa-eye-slash"></i>
                  </medsurf-design-content-chip>
                }
                <img class="w-full bg-black-alpha-30"
                  [src]="mediaControlService.getUrl(node.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="node?.title || 'global.error_loading_image' | translate" />
              </div>
              <div class="flex w-12rem align-items-start h-4rem p-2">
                <span class="overflow-hidden text-overflow-ellipsis-2">
                  {{ node.title }}
                </span>
              </div>
            </div>
          }
        </ng-template>
      </medsurf-design-content-sortable-data-view>
    }
  </div>
</div>

<!-- Modal -->
@if (isModal()) {
  <div
    class="flex flex-row justify-content-between">
    <div class="flex flex-row column-gap-2">
      <!-- Target -->
      @if (isModal()) {
        <medsurf-design-input-switch [formField]="false"
          [model]="target"
          [class]="'w-full'"
          [name]="'open_in_new_tab'"
        [label]="'global.open_in_new_tab'"></medsurf-design-input-switch>
      }
    </div>
    @let currentSelectedNode = searchControlFacade.currentSelectedNode$ | async;
    <!-- Close Modal Button -->
    <button medsurf-design-input-button [id]="'choose'"
      [label]="'global.choose' | translate"
      [disabled]="currentSelectedNode === null"
    (click)="currentSelectedNode && onModalSubmit(currentSelectedNode)"></button>
  </div>
}
